import "./error.css";

const Error = ({ message }: {message: string}) => {
    return (
        <span className="error-msg">{message}</span>
    )
};

export default Error;